import React from "react";
import Button from "@mui/material/Button";
import Colors from "./Colors";

function ButtonTransparent({ onClick, sx, ...props }) {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      sx={{
        boxShadow: "none",
        width: "100%",
        height: { xs: "32px", md: "48px" },
        backgroundColor: "transparent",
        borderRadius: "4px",
        color: Colors.black,
        whiteSpace: "nowrap",
        textTransform: "none",
        fontFamily: "IBM Plex Sans",
        padding: { xs: "8px 12px", md: "8px 12px" },
        fontSize: { xs: "12px", md: "16px" },
        fontWeight: "500",
        border: "1px solid ",
        borderColor: Colors.black,
        "&:hover": {
          background: Colors.secondary,
          textTransform: "none",
          color: Colors.black,
          boxShadow: "none",
        },
        ...sx,
      }}
      {...props}
    ></Button>
  );
}
export default ButtonTransparent;
